export enum EnvironmentType {
  Labs = 'labs',
  Staging = 'staging',
  Production = 'production',
}
